import React from "react"
import './menu-bar.css'
import logo from './xes-code-logo.png'
import OperationPanel from '../operation-panel'
import Input from '../input/input'
import { Menu, Dropdown} from 'antd'
import mblock from '../../lib/mblock-sdk'
import { getEnv, Environment, getXesEnvHanlder} from '../../lib/xes/xes'
import {connect} from 'react-redux';
import { setProjectTitle } from '../../reducers/project-title'
import { onXESInit } from '../../reducers/project-state'
import { Platform } from '../../lib/xes/xes'
// import {
//   isIPadAppFunction,
//   isWdFunction
// } from '../../lib/xes/common'
import xesBridge from 'xes-code-base/lib/libs/xes'
import http from "../../http";

const MenuBar = (props) => {

  function handleLogoClick () {
    // 不做跳转
    // let isOpenInApp = isIPadAppFunction() || isWdFunction()
    // if (!isOpenInApp) {
    //   const protocol = window.location.protocol
    //   window.location.assign(`${protocol}//code.xueersi.com`)
    // }
  }

  /**
   * @param {*} filename
   * @param {*} blob
   * @param {*} callback
   * @param {*} mustPCApp 必须是PC客户端才上传
   */
  const getUploadFile = (filename, blob, callback, mustPCApp) => {
    if(mustPCApp && !xesBridge.isWdFunction()) return false  // PC端才上传的判断
    let extName = filename.split('.').pop();
    let file = blob
      http.getUploadParams(extName)
        .then(res => {
          res = res[1]
          http.getUploadFile(res.host, file, res.header)
            .then(res2 => {
              if (callback) {
                callback(res.asurl)
              }
              console.log(res2)
            })
            .catch(res => {
              if (callback) {
                callback('')
              }
            })
        })
        .catch(res => {
          if (callback) {
            callback('')
          }
        })
      return true
  }

  const downloadSb3 = () => {
    if(xesBridge.isWdFunction()){
      mblock.download_app().then((blob)=>{
        let filename = props.projectTitle?props.projectTitle+'.zip':'project.zip'
        // filename, blob, callback, mustPCApp
        if( getUploadFile(filename, blob,
          function(url){
              // alert("等待端的调用："+url)
              xesBridge.downloadFormWD(url,filename)
          },true)) {
          return
        }
      })
    }else{
      mblock.download(props.projectTitle)
    }
  }

  // 项目加载完成
  mblock.onLoadedProject((projectInfo) => {
    if (Platform.isBrowser()) {
      if (projectInfo) {
        const { projectName } = projectInfo
        props.onUpdateReduxProjectTitle(projectName)
      }
    }
  })

  let additionalMenu = []

  if ([Environment.COMMUNITY].includes(getEnv())) {
    additionalMenu = [
      {
        label: '新建项目',
        handler() {
          getXesEnvHanlder().createNew(mblock.getCode())
        }
      }
    ]
  }

  if ([Environment.CLASSWORK, Environment.HOMEWORK, Environment.BAIZE].includes(getEnv())) {
    additionalMenu = [
      {
        label: '初始化作品',
        handler() {
          props.initProject()
        }
      }
    ]
  }

  const fileMenu = additionalMenu.concat([
    {
      label: '从电脑上传',
      handler() {
        mblock.upload()
      }
    },
    {
      label: '保存到电脑',
      handler() {
        downloadSb3()
      }
    }
  ])
  const fileDropDown = (
    <Menu>
      {
        fileMenu.map((item, index)=> 
              <Menu.Item key={index}>
                <div onClick={item.handler}>{ item.label }</div>
              </Menu.Item>
          )
      }
    </Menu>
  )

  return (
    <div className='menu-bar'>
      <div className='left-container'>
        < img className = 'menu-log'
        onClick = {
          handleLogoClick
        }
        src = {
          logo
        }
        alt = 'logo' / >
        <div>
          <Dropdown overlay={fileDropDown} trigger={['click']}>
            <div className='menu-bar-item'>文件</div>
          </Dropdown>
        </div>
        <div className='input-wrapper'>
          <Input value={props.projectTitle} onChange={props.onUpdateReduxProjectTitle}/>
        </div>
      </div>
      <div>
        <OperationPanel></OperationPanel>
      </div>
    </div>
  )
}

const mapStateToProps = state => ({
    getCode: mblock.getCode,
    projectTitle: state.scratchGui.projectTitle,
    xesProjectMeta: state.scratchGui.xesProjectState.xesProjectMeta,
    state
});

const mapDispatchToProps = dispatch => ({
    onUpdateReduxProjectTitle: title => {
        dispatch(setProjectTitle(title))
    },
    initProject: () => dispatch(onXESInit())
});

export default connect(
                    mapStateToProps,
                    mapDispatchToProps
                )(MenuBar)

